<template>
  <component
      :is="wrapperComponent"
      v-bind="wrapperProps"
      @click.stop
  >
    <VButton @click="onEdit">
      <VIcon material="edit" />
      Редактировать
    </VButton>
    <VButton @click="onCopy">
      <VIcon material="content_copy" />
      Копировать
    </VButton>
    <VButton @click="onDelete">
      <VIcon material="delete" />
      Удалить
    </VButton>
  </component>
</template>

<script lang="ts">
import VContextMenuButton from '@/lib/components/VContextMenuButton/VContextMenuButton.vue';

export default {
  name: 'PositionContextMenu',
  props: {
    row:       {
      type:     Object,
      required: true,
    },
    useButton: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      localVisible: false,
    };
  },
  computed: {
    wrapperComponent() {
      return this.useButton ? VContextMenuButton : 'div';
    },
    wrapperProps() {
      if (!this.useButton) {
        return { class: 'popup-menu' };
      }
      return {
        visible:            this.localVisible,
        'update:visible': (val) => {
          console.log('val: ', val);
          this.localVisible = val;
        },
        theme:              'default',
      };
    },
  },
  methods: {
    closeMenu() {
      if (this.useButton) {
        this.localVisible = false;
      }
    },
    onEdit() {
      this.$emit('edit', this.row);
      this.closeMenu();
    },
    onCopy() {
      this.$emit('copy', this.row);
      this.closeMenu();
    },
    onDelete() {
      this.$emit('delete', this.row);
      this.closeMenu();
    },
  },
}
</script>
